const label = {
  companyName: "TrainingPort.net",
  companyLogo: "/static/img/tp_logo_white.png",
  companySecondVersionLogo: "/static/img/tp_logo_blue.png",
  companyWhiteVersionLogo: "/static/img/tp_logo_white.png",
  croppedCompanyLogo: "/static/img/cropped_tp_logo_white.png",
  croppedCompanyLogoSecondVersionLogo: "/static/img/cropped_tp_logo_blue.png",
  reservedRightsWebSite: "TrainingPort.net"
};

export default label;
